import styled from "styled-components";

export const PaymentMethodValueField = styled.div`
  grid-column: 1 / -1;
`;
